import { render, staticRenderFns } from "./TriggersSettingsModal.vue?vue&type=template&id=48c16b0a&scoped=true&"
import script from "./TriggersSettingsModal.vue?vue&type=script&lang=js&"
export * from "./TriggersSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c16b0a",
  null
  
)

export default component.exports